const ClearOptions = (folioSelect) => {
  const currentOptions = folioSelect.querySelectorAll('option')

  currentOptions.forEach((option) => {
    if(!option.hasAttribute('disabled')) option.remove()
  })
}

const addOptions = (data, folioSelect) => {
  const option = document.createElement("option")
  option.text = data.folio
  option.value = data.id

  folioSelect.appendChild(option)
}

const GetDistributorFolio = () => {
  const distributors = document.querySelectorAll('[get-distributor-folio]')

  if(!distributors.length > 0) return

  distributors.forEach((distributor) => {
    distributor.addEventListener('change', (e) => {
      const distributorId = e.currentTarget.value
      const folioSelect = distributor.closest('form').querySelector('[set-distributor-folio]')

      ClearOptions(folioSelect)

      axios.get(`/api/facturas?distributor=${distributorId}`)
      .then(function (response) {
        response.data.data.forEach((data) => {
          addOptions(data, folioSelect)
        })
      })
      .catch(function (error) {
        // console.log(error)
      })
    })
  })

}
export default GetDistributorFolio
